var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 35.215,
    viewBox: "0 0 20 35.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.441 93.476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.832-58.261l-2.39-2.39L42.659-75.869,27.441-91.086l2.39-2.39,17.61,17.608Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.6deb9d990e5f2fa29ffd29b16bf8ef3e.svg";
export { ForwardRef as ReactComponent };